import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "seller-comments-label" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "seller-comments-empty"
}
const _hoisted_4 = { class: "seller-comments-meta" }
const _hoisted_5 = ["disabled", "onClick"]
const _hoisted_6 = {
  key: 2,
  class: "seller-comments-empty"
}
const _hoisted_7 = ["rows"]
const _hoisted_8 = { class: "seller-comments-actions" }
const _hoisted_9 = ["disabled"]

import { ref, watch } from "vue";
import { fetchRest, getApiBaseUrl } from "@/config/api";
import { ConfirmModal } from "@/components";
import { useNotification } from "@/composables/useNotification";

interface SellerComment {
  id_vendeur_commentaire: number;
  commentaire: string;
  date_creation: string;
  prenom?: string | null;
  nom?: string | null;
  canDelete?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminSellerComments',
  props: {
    idVendeur: {},
    panel: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { success, error: notifyError } = useNotification();
const comments = ref<SellerComment[]>([]);
const expanded = ref(false);
const draft = ref("");
const loading = ref(false);
const saving = ref(false);
const pendingDelete = ref<SellerComment | null>(null);

const authorName = (item: SellerComment) =>
  `${item.prenom || ""} ${item.nom || ""}`.trim() || "Admin";

const formatDateTime = (value?: string) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const load = async () => {
  if (!props.idVendeur) {
    comments.value = [];
    return;
  }
  loading.value = true;
  try {
    const response = await fetchRest(
      `${getApiBaseUrl()}/api/admin-efp/vendeurs/commentaires/get`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idVendeur: props.idVendeur }),
      },
    );
    const data = await response.json();
    comments.value = Array.isArray(data) ? data : [];
  } catch {
    notifyError("Impossible de charger les commentaires.");
    comments.value = [];
  } finally {
    loading.value = false;
  }
};

const save = async () => {
  const commentaire = draft.value.trim();
  if (!commentaire || saving.value) return;
  saving.value = true;
  try {
    const response = await fetchRest(
      `${getApiBaseUrl()}/api/admin-efp/vendeurs/commentaires/save`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idVendeur: props.idVendeur, commentaire }),
      },
    );
    const created = await response.json();
    if (created?.id_vendeur_commentaire) {
      comments.value = [...comments.value, created];
      draft.value = "";
      success("Commentaire enregistré.");
    } else {
      notifyError("Le commentaire n'a pas été enregistré.");
    }
  } catch {
    notifyError("Impossible d'enregistrer le commentaire.");
  } finally {
    saving.value = false;
  }
};

const remove = (item: SellerComment) => {
  if (!item.canDelete || saving.value) return;
  pendingDelete.value = item;
};

const confirmRemove = async () => {
  const item = pendingDelete.value;
  if (!item || saving.value) return;
  saving.value = true;
  try {
    const response = await fetchRest(
      `${getApiBaseUrl()}/api/admin-efp/vendeurs/commentaires/delete`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idVendeur: props.idVendeur,
          idCommentaire: item.id_vendeur_commentaire,
        }),
      },
    );
    const deleted = await response.json();
    if (deleted === true) {
      comments.value = comments.value.filter(
        (comment) => comment.id_vendeur_commentaire !== item.id_vendeur_commentaire,
      );
      pendingDelete.value = null;
      success("Commentaire supprimé.");
    } else {
      notifyError("Ce commentaire ne peut pas être supprimé.");
      pendingDelete.value = null;
    }
  } catch {
    notifyError("Impossible de supprimer le commentaire.");
    pendingDelete.value = null;
  } finally {
    saving.value = false;
  }
};

watch(() => props.idVendeur, () => void load(), { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["seller-comments", { 'seller-comments-panel': _ctx.panel }])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "seller-comments-toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
    }, [
      _createElementVNode("span", _hoisted_1, [
        _cache[4] || (_cache[4] = _createTextVNode(" Commentaires")),
        (comments.value.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(comments.value.length) + ")", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("i", {
        class: _normalizeClass(expanded.value ? 'fas fa-chevron-up' : 'fas fa-chevron-down')
      }, null, 2)
    ]),
    _withDirectives(_createElementVNode("div", null, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Chargement..."))
        : _createCommentVNode("", true),
      (comments.value.length)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 1,
            class: "seller-comments-list",
            onWheel: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id_vendeur_commentaire
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(authorName(item)) + " · " + _toDisplayString(formatDateTime(item.date_creation)), 1),
                  (item.canDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        title: "Supprimer le commentaire",
                        disabled: saving.value,
                        onClick: ($event: any) => (remove(item))
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
                      ]), 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", null, _toDisplayString(item.commentaire), 1)
              ]))
            }), 128))
          ], 32))
        : (!loading.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Aucun commentaire."))
          : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((draft).value = $event)),
        rows: _ctx.panel ? 1 : 2,
        maxlength: "256",
        placeholder: "Écrivez votre commentaire..."
      }, null, 8, _hoisted_7), [
        [_vModelText, draft.value]
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(draft.value.trim().length) + "/256", 1),
        _createElementVNode("button", {
          type: "button",
          disabled: saving.value || !draft.value.trim(),
          onClick: save
        }, " Enregistrer ", 8, _hoisted_9)
      ])
    ], 512), [
      [_vShow, expanded.value]
    ]),
    _createVNode(_unref(ConfirmModal), {
      show: pendingDelete.value != null,
      title: "Supprimer le commentaire",
      message: "Supprimer ce commentaire ?",
      "confirm-text": "Supprimer",
      "confirm-button-class": "bg-red-600 hover:bg-red-700 focus:ring-red-500",
      "confirm-loading": saving.value,
      "loading-text": "Suppression…",
      onConfirm: confirmRemove,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (pendingDelete.value = null))
    }, null, 8, ["show", "confirm-loading"])
  ], 2))
}
}

})